import VerifyEmailCode from 'features/otp/challenges/VerifyEmailCode/VerifyEmailCode';
import React from 'react';

export default function Page() {
  return <VerifyEmailCode />;
}
